<template>
  <div>
    <div class="container"
         v-if="list.length>0">
      <div class="container_item"
           v-for="item in list"
           :key="item.lId">
        <p class="item_title">
          <span class="title_name"><span>{{item.group && item.group.egName}}</span></span>
        </p>
        <div class="con"
             @click="toDetails(item.lId)">
          <img class="con_images"
               :src="item.lPicUrl"
               alt="">
          <div class="con_right">
            <p class="con_title">{{item.lTitle}}</p>
            <div>
              <p class="con_author">{{item.lSpeaker}}</p>
              <p class='con_org'>{{item.teacher && item.teacher.tOrg}} {{item.teacher && item.teacher.tPost}}</p>
            </div>
          </div>
        </div>
        <div class="num_type">
          <p><img src="../../assets/images/time.png"
                 class="see"
                 alt=""> <span class="title_time">{{getTimes(item.lDt)}}</span></p>
          <!-- <p><span :class="{'no-public': item.vIsPublic==0}"><span v-if="item.vIsPublic==0">非</span>公开课</span></p> -->
        </div>
      </div>
    </div>
    <div class="none"
         v-if="list.length<1">
      <img src="../../assets/images/none.png"
           alt="">
      <p>暂无预约</p>
    </div>

  </div>
</template>
<script>
import AppSetting from '../../AppSetting';
import loginService from '../../plugin/extendFn/loginService';
export default {
  data () {
    return {
      l_type: [
        { name: '注册与检测', id: 1 },
        { name: '质量体系', id: 2 },
        { name: '临床试验与评价', id: 3 },
        { name: '上市后经营与监管', id: 4 },
        { name: '产品市场与销售', id: 5 },
      ],
      list: [],
      wxuser: null,
    }
  },
  props: {},
  methods: {
    getFile (event) {
      var file = event.target.files;
      console.log(file)
      for (var i = 0; i < file.length; i++) {
        //    上传类型判断
        var imgName = file[i].name;
        var idx = imgName.lastIndexOf(".");
        if (idx != -1) {
          var ext = imgName.substr(idx + 1).toUpperCase();
          ext = ext.toLowerCase();
          if (ext != 'pdf' && ext != 'doc' && ext != 'docx') {

          } else {
            this.addArr.push(file[i]);
          }
        } else {

        }
      }
      console.log(this.addArr)
    },
    getList () {
      this.$postHttp(AppSetting.baseUrl + '/student/appointment', { id: this.wxuser.uId }).then((res) => {
        // console.log(res);
        if (res.data.code == 0) {
          this.list = res.data.list;
        }
      })
    },
    getTimes (value) {
      return new Date(value).Format("yyyy.MM.dd hh:mm");
    },
    toDetails (id) {
      this.$router.push({
        name: "Details",
        query: { type: "live", liveId: id }
      })
    },
  },
  computed: {},
  async mounted () {
    this. wxuser = await loginService.getLoginUser();
    this.getList();
    setTimeout(() => {
      document.title = '我的预约'
    }, 300)

  }
}
</script>
<style scoped lang="scss">
.none {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  padding-top: 2.64rem;
  box-sizing: border-box;
  img {
    width: 100%;
  }
  p {
    font-size: 0.38rem;
    color: #666666;
    text-align: center;
  }
}
.container {
  background: #f4f5f4;
  min-height: 100vh;
  // padding-top: 0.2rem;
  /*box-sizing: border-box;*/
  .container_item {
    background: #ffffff;
    padding-left: 0.3rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    .item_title {
      padding-right: 0.3rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      padding-top: 0.16rem;
      padding-bottom: 0.21rem;
      .title_name {
        font-size: 0.26rem;
        color: #666666;
      }
    }
    .title_time {
      display: flex;
      align-items: center;
      img {
        width: 0.3rem;
        margin-left: 0.16rem;
        /*height: 0.28rem;*/
      }
      font-size: 0.24rem;
      color: #999999;
    }
    .con {
      border-bottom: 1px solid #e6e6e6;
      box-sizing: border-box;
      padding-bottom: 0.16rem;
      height: 1.77rem;
      display: flex;
      align-items: flex-start;
      .con_right {
        height: 1.62rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .con_images {
        width: 2.84rem;
        height: 1.6rem;
        margin-right: 0.22rem;
      }
      .con_title {
        width: 3.47rem;
        font-size: 0.28rem;
        color: #333333;
        height: 0.71rem;
        line-height: 0.38rem;
        -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
        -webkit-line-clamp: 2; /*限制文本行数*/
        font-weight: bold;
        /*white-space: nowrap;      !*超出的空白区域不换行*!*/
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis; /*文本超出显示省略号*/
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /* autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        -webkit-line-clamp: 2;
      }
      .con_author {
        /*margin-top: 0.68rem;*/
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 3.47rem;
        color: #333333;
        font-size: 0.26rem;
      }
      .con_org {
        font-size: 0.26rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 3.47rem;
      }
    }
    .num_type {
      font-size: 0.24rem;
      height: 0.6rem;
      display: flex;
      align-items: center;
      p {
        width: 3.44rem;
        display: flex;
        align-items: center;
        justify-content: start;
        height: 0.28rem;
        color: #666666;
      }
      img {
        margin-right: 0.2rem;
      }
      .see {
        width: 0.4rem;
      }
      .lesson {
        width: 0.4rem;
        color: #ffb400;
      }

      .no-public {
        color: #2bcf4a;
      }
      p:nth-of-type(2) {
        justify-content: flex-end;
        color: #ffb400;
      }
    }
  }
  .last {
    display: flex;
    height: 0.8rem;
    justify-content: space-between;
    padding-right: 0.29rem;
    align-items: center;
    button {
      width: 1.4rem;
      height: 0.5rem;
      background: linear-gradient(
        0deg,
        rgba(9, 131, 255, 1) 0%,
        rgba(33, 175, 255, 1) 100%
      );
      border-radius: 25px;
      font-size: 0.26rem;
      color: #ffffff;
      border: none;
      outline: none;
    }
  }
  .footer_type {
    font-size: 0.26rem;
    color: #ffb400;
  }
  .textColor {
    color: #2bcf4a;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/me/bespoke.vue